<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <!-- <b-button block variant="info" @click="doExport">
          <i class="fa fa-print" aria-hidden="true"></i>Xuất File
        </b-button> -->

        <download-excel
          class="btn btn-primary btn-block"
          :data="invoiceProducts"
          :fields="invoiceFields"
          worksheet="My Worksheet"
          name="mfilename.xls"
        >
          <i class="fa fa-file-export"></i>
          Xuất file Excel
        </download-excel>
      </b-col>
      <b-col sm="12" md="4">
        <b-button @click="createInvoice" block variant="success">
          <i class="fa fa-file-invoice-dollar" aria-hidden="true"></i>
          Tạo hóa đơn
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print" class="print-box mt-3 mb-3" style="max-width:1080; font-size:12px">
        <div class="header text-center">
          <h3>HÓA ĐƠN GIÁ TRỊ GIA TĂNG</h3>
          (VAT INVOICE)<br />
          Ngày :
          <input style="line-height: 15px;" v-model="invoiceSummary.invoiceIssuedDate" type="date" /><br />
        </div>
        <div class="">
          <table class="prtable">
            <tr style="border-top:1px solid; border-bottom:1px solid">
              <td style="text-align: left;">
                <span><b>Đơn vị bán hàng</b>: {{ config.COMPANY_NAME }}</span>
                <br />
                <span><b>Mã số thuế</b> : {{ config.COMPANY_TAXCODE }}</span>
                <br />
                <span><b>Địa chỉ</b> : {{ config.COMPANY_ADDRESS }}</span>
                <br />
                <span><b>Điện thoại</b>: {{ config.COMPANY_PHONE }}</span>
              </td>
              <td style="text-align: left;">
                <br /><br /><br />
                <b>Số tài khoản</b> :
              </td>
            </tr>
            <tr>
              <td style="text-align: left;">
                <span> <b>Họ tên người mua hàng</b>: </span>
                <br />
                <span><b>Tên đơn vị</b>: {{ order.customer.name }}</span> <br />
                <span><b>Mã số thuế</b> : {{ order.customer.taxCode }}</span>
                <br />
                <span><b>Địa chỉ</b> : {{ order.customer.address }}</span>
                <br />
                <span>
                  <b>Hình thức thanh toán</b> :
                  <select v-model="invoiceSummary.paymentMethodName">
                    <option value="TM/CK">TM/CK</option>
                    <option value="CK">CK</option>
                    <option value="TM">TM</option>
                    <option value="DTCN">DTCN</option>
                    <option value="KHAC">KHAC</option>
                  </select>
                </span>
              </td>
              <td style="text-align: left;">
                <br /><br /><br />
                <br />
                <b>Số tài khoản</b> :
              </td>
            </tr>
          </table>
        </div>
        <div class="data">
          <table class="prtable prtable-bordered">
            <thead>
              <tr>
                <th style="width:1px">STT.</th>
                <th style="min-width:130px">Sản Phẩm</th>
                <th>Đơn vị tính</th>
                <th>Số lượng</th>
                <th>Đơn giá (VNĐ)</th>
                <th>Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in invoiceProducts" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.productText }}</td>
                <td>{{ $ucWord(item.unit) }}</td>
                <td>
                  <!-- {{ $formatNumber(item.quantity) }} -->
                  <base-input @change="updateSummary" v-model="item.quantity" :mask="'number'"></base-input>
                </td>
                <td>{{ $formatNumber(item.price) }}</td>
                <td class="text-right">
                  {{ $formatNumber(Number(item.price) * Number(item.quantity)) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td style="text-align:right" colspan="5"><b>Cộng tiền hàng</b>:</td>
                <td style="text-align:right">
                  {{ $formatNumber(invoiceSummary.totalAmountWithoutTax) }}
                </td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left;">
                  <b>Thuế suất GTGT</b>:
                  <select @change="updateTotalAmount" v-model="invoiceSummary.tax">
                    <option value="10">10%</option>
                    <option value="8">8%</option>
                    <option value="0">0%</option>
                    <option value="5">5%</option>
                    <option value="15">15%</option>
                    <option value="20">20%</option>
                    <option value="25">25%</option>
                    <option value="KHAC">Không thuế</option>
                  </select>
                </td>
                <td colspan="2" style="text-align:right"><b>Tiền thuế GTGT</b>:</td>
                <td style="text-align:right">
                  {{ $formatNumber(invoiceSummary.totalTaxAmount) }}
                </td>
              </tr>
              <tr>
                <td colspan="5" style="text-align:right"><b>Tổng cộng tiền thanh toán</b>:</td>
                <td style="text-align:right">
                  {{ $formatNumber(invoiceSummary.totalAmountWithTax) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
import JsonExcel from 'vue-json-excel';
import { orderService } from '@/_services';
import { mapState } from 'vuex';
export default {
  props: {},
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      visible: false,
      showPrice: true,
      order: {
        id: '',
        customer: {},
        customerContact: {}
      },
      invoiceFields: {
        STT: 'stt',
        'Sản phẩm': 'productText',
        'Đơn vị tính': 'unit',
        'Số lượng': 'quantity',
        'Đơn giá': 'price',
        'Thành tiền': 'total'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      productOrders: [],
      invoiceProducts: [],
      invoiceSummary: {
        tax: 10,
        total: 0,
        exchangeRate: '', // Tỉ giá ngoại tệ
        currencyCode: 'VND', // Mã tiền tệ
        invoiceIssuedDate: this.$today('YYYY-MM-DD'), // Ngày lập hóa đơn,
        totalAmountWithoutTax: 0, // Tổng thành tiền chưa VAT
        totalTaxAmount: 0, //Tổng tiền thuế
        totalAmountWithTax: 0, //Tổng tiền đã bao gồm VAT
        paymentMethodName: 'TM/CK'
      }
    };
  },
  computed: {
    ...mapState('config', ['config'])
  },
  methods: {
    setData(order, productOrders) {
      this.order = order;

      productOrders.sort((a, b) => {
        if (a.product.name < b.product.name) {
          return -1;
        }
        if (a.product.name > b.product.name) {
          return 1;
        } else {
          if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
            return 1;
          }
          if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
            return -1;
          }
          return 0;
        }
      });
      this.invoiceProducts = [];
      this.invoiceSummary.totalAmountWithoutTax = 0;
      this.invoiceSummary.tax = order.customer.tax;

      for (let i = 0; i < productOrders.length; i++) {
        let item = productOrders[i];
        this.invoiceProducts.push({
          stt: i + 1,
          productText: item.product.name + ' ' + item.productSpecify.name + ' mm' + ' - ' + item.color.label,
          product: item.product,
          unit: item.unit,
          quantity: item.quantity - item.quantityExported,
          price: item.price,
          total: item.price * (item.quantity - item.quantityExported),
          id: item.id
        });
        this.invoiceSummary.totalAmountWithoutTax += item.total;
        item.rowSpan = this.checkSameRow(productOrders, i, (a, b) => {
          return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
        });
      }

      this.invoiceSummary.totalTaxAmount = (this.invoiceSummary.totalAmountWithoutTax * this.invoiceSummary.tax) / 100;
      this.invoiceSummary.totalAmountWithTax =
        this.invoiceSummary.totalAmountWithoutTax + this.invoiceSummary.totalTaxAmount;
      console.log('config', this.config);
      console.log('xxxx', productOrders, this.invoiceSummary);
      this.productOrders = productOrders;
    },
    updateTotalAmount() {
      if (this.invoiceSummary.tax == 'KHAC') {
        this.invoiceSummary.totalTaxAmount = (this.invoiceSummary.totalAmountWithoutTax * 0) / 100;
        this.invoiceSummary.totalAmountWithTax =
          this.invoiceSummary.totalAmountWithoutTax + this.invoiceSummary.totalTaxAmount;
      } else {
        this.invoiceSummary.totalTaxAmount =
          (this.invoiceSummary.totalAmountWithoutTax * this.invoiceSummary.tax) / 100;
        this.invoiceSummary.totalAmountWithTax =
          this.invoiceSummary.totalAmountWithoutTax + this.invoiceSummary.totalTaxAmount;
      }
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    updateSummary() {
      let totalAmountWithoutTax = 0;
      for (let i = 0; i < this.invoiceProducts.length; i++) {
        const element = this.invoiceProducts[i];
        totalAmountWithoutTax += element.price * element.quantity;
      }
      this.invoiceSummary.totalAmountWithoutTax = totalAmountWithoutTax;
      this.invoiceSummary.totalTaxAmount = (this.invoiceSummary.totalAmountWithoutTax * this.invoiceSummary.tax) / 100;
      this.invoiceSummary.totalAmountWithTax =
        this.invoiceSummary.totalAmountWithoutTax + this.invoiceSummary.totalTaxAmount;
    },
    doPrint() {
      this.$print('print');
    },
    createInvoice() {
      this.$refs.bmdal.block();
      this.invoiceSummary.invoiceIssuedDate = this.$toMillisecondTimestamp(this.invoiceSummary.invoiceIssuedDate);
      orderService
        .invoice(this.invoiceSummary, this.invoiceProducts, this.order.id)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .catch(err => {
          if (err.data) {
            err.data.forEach(element => {
              let errObj = {};
              errObj[element.context.key] = [element.message];
              self.$refs.csInfo.setErrors(errObj);
            });
          }
        })
        .finally(() => {
          this.$refs.bmdal.unBlock();
        });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>

<style lang="scss">
.print-box {
  .prtable.prtable-bordered th {
    font-size: 12px;
  }
}
</style>
